import { render, staticRenderFns } from "./OwnerAccountBalance.vue?vue&type=template&id=6bd699eb&scoped=true&"
import script from "./OwnerAccountBalance.vue?vue&type=script&lang=js&"
export * from "./OwnerAccountBalance.vue?vue&type=script&lang=js&"
import style0 from "./OwnerAccountBalance.vue?vue&type=style&index=0&id=6bd699eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd699eb",
  null
  
)

export default component.exports